import { render, staticRenderFns } from "./treatment-details.vue?vue&type=template&id=77c206c0&"
import script from "./treatment-details.vue?vue&type=script&lang=js&"
export * from "./treatment-details.vue?vue&type=script&lang=js&"
import style0 from "./treatment-details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports